import React from 'react';

const Pagination = ({ paginationData, onPaginationChange, paginationRef, t }) => {
    if (!paginationData) {
        return null;
    }

    return (
        <div ref={paginationRef} className="row mb-2 pagination-wrapper">
            <div className="col-12 col-md-4 pagination-total-items" style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ fontWeight: "400", color: 'var(--bodyText)', marginBottom: 0 }}>
                    {t('sort.totalItems')}: {paginationData.totalItems}
                </span>
            </div>
            <div className="col-12 col-md-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40px' }}>
                {/* {paginationData.currentPage > 1 ? (
                    <button
                        className="btn btn-primary"
                        onClick={(e) => onPaginationChange(e, paginationData.currentPage - 1)}>
                        {t('sort.previousPage')}
                    </button>
                ) : paginationData.currentPage < paginationData.pages ? (
                    <button
                        className="btn btn-primary"
                        onClick={(e) => onPaginationChange(e, paginationData.currentPage + 1)}>
                        {t('sort.nextPage')}
                    </button>
                ) : null} */}
            </div>
            <div className="col-12 col-md-4 pagination-controls" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '15px' }}>
                <div className="d-flex align-items-center">
                    <select
                        name="listDisplayElements"
                        value={paginationData.limit}
                        className="display-elements-control"
                        onChange={onPaginationChange}
                    >
                        <option value="10">10 {t('sort.perPage')}</option>
                        <option value="25">25 {t('sort.perPage')}</option>
                        <option value="50">50 {t('sort.perPage')}</option>
                        <option value="100">100 {t('sort.perPage')}</option>
                    </select>
                </div>
                <div className="pagination-control" style={{ marginRight: '12px' }}>
                    <span className="pagination-text">
                        {paginationData.startItem} - {paginationData.endItem} od {paginationData.totalItems}
                    </span>
                    <span className="pagination-separator"></span>
                    <button
                        className="pagination-btn"
                        onClick={(e) => {
                            if (paginationData.currentPage > 1) {
                                onPaginationChange(e, paginationData.currentPage - 1);
                            }
                        }}
                    >
                        <i className="mdi mdi-chevron-left"></i>
                    </button>
                    <span className="pagination-separator"></span>
                    <button
                        className="pagination-btn"
                        onClick={(e) => {
                            if (paginationData.currentPage < paginationData.pages) {
                                onPaginationChange(e, paginationData.currentPage + 1);
                            }
                        }}
                    >
                        <i className="mdi mdi-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Pagination;

